export default __webpack_public_path__ + "media/Seasoning-Cooking-Powder.b178a1e8.png";